import React from 'react'

const ResultMainSeriesItem = ({ text, value }) => {
  return (
    <div>
        <p>{text}</p>
        <p>{value}</p>
    </div>
  )
}

export default ResultMainSeriesItem